import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Components
import Layout from './components/Layout';
import Home from './components/Home';
import Members from './components/Members';
import MemberDetail from './components/MemberDetail';
import WeeklyHighlight from './components/WeeklyHighlight';
import Events from './components/Events';
// import SpecialEvents from './components/SpecialEvents';
import MemberDataGenerator from './components/MemberDataGenerator';
import EventDataGenerator from './components/EventDataGenerator';

// Simple 404 component for special-events route
const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-dark-DEFAULT">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-primary-DEFAULT mb-4">404</h1>
      <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">Page not found</p>
      <a
        href="/"
        className="bg-primary-DEFAULT hover:bg-primary-dark text-white font-bold py-2 px-4 rounded transition-colors duration-300"
      >
        Go Home
      </a>
    </div>
  </div>
);


function App() {
  return (
    <div className='min-h-screen bg-gray-50 dark:bg-dark-DEFAULT text-gray-900 dark:'>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='members' element={<Members />} />
          <Route path='members/:memberId' element={<MemberDetail />} />
          <Route path='highlight' element={<WeeklyHighlight />} />
          <Route path='/events' element={<Events />} />
          <Route path='/special-events' element={<NotFound />} />
          <Route path='/member-generator' element={<MemberDataGenerator />} />
          <Route path="/event-generator" element={<EventDataGenerator />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
